<template>
  <div class="serverPackageDetail">
    <div class="server-list">
      <div class="server-list-item" v-for="service in serviceList" :key="service.id">
        <div class="icon">
          <img class="img" :src="service.urlDetailed" :alt="service.name">
        </div>
        <div class="content">
          <div class="title">{{ service.name }}</div>
          <div class="desc">{{ service.remark }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServerPackageDetail',
  data () {
    return {
      serviceList: []
    }
  },
  computed: {
    orderNo () {
      return this.$route.query.orderNo || ''
    },
    agreementId () {
      return this.$route.query.agreementId || ''
    }
  },
  created () {
    this.querycourseServer()
  },
  methods: {
    querycourseServer () { // 查询病程管理服务
      this.$post('/doctorOrder/courseServer.action', {
        orderNo: this.orderNo,
        agreementId: this.agreementId
      }).then(res => {
        if (res.respCode === 1001 && res.data) {
          this.serviceList = res.data.servers
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.serverPackageDetail {
  .server-list {
    &-item {
      padding: .39rem .47rem .3rem .24rem;
      display: flex;
      // align-items: center;
      border-bottom: 1px solid #EEEEEE;
      .icon {
        flex: 0 0 .7rem;
        width: .68rem;
        height: .68rem;
        margin-right: .26rem;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        .title {
          font-size: .32rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 1;
        }
        .desc {
          font-size: .28rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: .15rem;
          line-height: .42rem;
        }
      }
    }
  }
  .footer-tips {
    margin-top: .29rem;
    .tips {
      padding-left: .24rem;
      font-size: .24rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #DA0428;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/diseaseManageDetail.vue